const state = { all: {} };
import { apiService } from "@/_services";
import { commodityTooltip } from "@/_core/_helpers/_helpers";

const actions = {
  async getAll({ commit }) {
    let params = {
      method: "GET",
      endpoint: "commodities",
      content_type: "application/json",
      query_params: {
        format: "json"
      }
    };
    commit("getAllRequest");
    await apiService
      .getAll(params)
      .then(data => {
        data.forEach(function(d) {
          d.text = commodityTooltip(d);
        });
        commit("getAllSuccess", data);
      })
      .catch(error => {
        console.log(error);
        commit("getAllFailure", error);
      });
  },
  logout({ commit }) {
    commit("logout");
  }
};

const mutations = {
  getAllRequest(state) {
    state.all = { loading: true };
  },
  getAllSuccess(state, commodities) {
    state.all = { items: commodities };
  },
  getAllFailure(state, error) {
    state.all = { error };
  },
  logout(state) {
    state.all = null;
  }
};

export const commodities = {
  namespaced: true,
  state,
  actions,
  mutations
};
